import React, { useContext } from "react";

import { FullscreenOverlay } from "@/common/FullscreenOverlay";
import { GlobalContext } from "@/contexts";
import { Icons } from "@/styles";
import { Animations } from "@/styles/Mixins";
import Svg from "@/styles/Svg";
import { isTouchDevice } from "@/utils/getters";

import {
  LightContainer,
  LightIconWrapper,
  OverlayClose,
  OverlayContent,
  OverlayWrapper,
} from "./styles";

export type OutroOverlayProps = {
  onClose: () => void;
  children?: React.ReactNode;
  hasTopPadding: boolean;
  lightLayout: boolean;
  hasScrollbar: boolean;
};

const OutroOverlay: React.FC<OutroOverlayProps> = (
  props: OutroOverlayProps
): React.JSX.Element => {
  const { onClose, hasTopPadding, lightLayout, hasScrollbar } = props;
  const globalContext = useContext(GlobalContext);

  const forceClose = () => {
    if (!isTouchDevice()) {
      onClose();
    }
  };

  return (
    <FullscreenOverlay
      onClose={forceClose}
      animation={Animations.MOVE_UP_AND_FADE_IN}
      hasScrollbar={hasScrollbar}
    >
      {lightLayout ? (
        <LightContainer>
          <LightIconWrapper data-qa={"outro:close"} onClick={onClose}>
            <Svg contents={Icons.Close} width={14} height={14} />
          </LightIconWrapper>
          {props.children}
        </LightContainer>
      ) : (
        <OverlayWrapper>
          <OverlayContent hasTopPadding={hasTopPadding}>
            <OverlayClose data-qa={"outro:close"} onClick={onClose}>
              <Svg
                contents={globalContext.icons.Close}
                height={18}
                width={18}
              />
            </OverlayClose>
            {props.children}
          </OverlayContent>
        </OverlayWrapper>
      )}
    </FullscreenOverlay>
  );
};

export default OutroOverlay;
